import React from 'react';
import get from 'lodash/get';
import Tabs from '@components/common/Dashboard/DashboardTabs/Tabs';
import { TAB_TITLE_AI_ROADMAP } from '@utils/constants';
import { HeaderPanelWrapper } from './styled';

interface PropTypes {
  pageType: number;
  history: any;
  match: any;
}

const HeaderPanel = (props: PropTypes) => {
  const { history, pageType, match } = props;
  const currentShareId = get(match, 'params.id', TAB_TITLE_AI_ROADMAP);

  return (
    <HeaderPanelWrapper>
      <Tabs currentShareId={currentShareId} history={history} pageType={pageType} />
    </HeaderPanelWrapper>
  );
};

export default HeaderPanel;
